// @ts-nocheck

import dayjs from 'dayjs'
import _ from 'lodash'
import { regexp } from '../constants'
import { isValidNhsNumber } from './functions'

const validDate = ({ value, label }) => {
  const date = dayjs(value, DATE_FORMAT, true)
  if (!date.isValid || !date.isValid()) {
    return {
      isValid: false,
      message: `${label} is incorrectly formatted (${DATE_FORMAT})`
    }
  }
  return {
    isValid: true,
    message: ''
  }
}

const validation = {
  birthdate: ({ value }) => {
    const birthdate = dayjs(value, DATE_FORMAT)
    const cutOffDate = dayjs('01/01/1900', DATE_FORMAT)
    if (birthdate.isAfter(dayjs())) {
      return {
        isValid: false,
        message: 'Date of birth cannot be in the future'
      }
    }
    if (birthdate.isBefore(cutOffDate)) {
      return {
        isValid: false,
        message: 'Date of birth cannot be before 1900'
      }
    }
    if (!birthdate.isValid()) {
      return {
        isValid: false,
        message: 'Invalid date of birth'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },
  date: ({ value }) => {
    const date = dayjs(value, DATE_FORMAT)
    if (!date.isValid()) {
      return {
        isValid: false,
        message: 'Invalid date of birth'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },
  email: ({ value, label }) => ({
    isValid: regexp.email.test(value),
    message: `Invalid ${label}`
  }),

  // For endDate, relatedValues is a single-entry array, with the
  // start date as the entry.
  endDate: ({ value, relatedValues }) => {
    const endDate = dayjs(value, DATE_FORMAT)
    const startDate = dayjs(relatedValues[0], DATE_FORMAT)

    if (startDate.isBefore(endDate)) {
      return {
        isValid: true,
        message: ''
      }
    }
    return {
      isValid: false,
      message: 'Start date must be before end date'
    }
  },
  futureDate: ({ value, label }) => {
    const date = dayjs(value, DATE_FORMAT)
    if (date.isBefore(dayjs())) {
      return {
        isValid: false,
        message: `${label} cannot be in the past`
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },
  medDaysInWeek: ({ value, relatedValues }) => {
    const weekdays = value
    const startDate = relatedValues[0]

    if (!startDate) {
      return {
        isValid: true
      }
    }

    return weekdays.includes(dayjs(startDate, 'DD-MM-YYYY').format('ddd'))
      ? {
          isValid: true
        }
      : {
          isValid: false,
          message: `Start date is on a ${dayjs(startDate, 'DD-MM-YYYY').format(
            'dddd'
          )}`
        }
  },
  nationalInsurance: ({ value }) => ({
    isValid: !!value.match(regexp.nationalInsurance),
    message: 'Invalid National Insurance number'
  }),
  canadaNhsNumber: ({ value }) => {
    return {
      isValid: value.length === 12,
      message: 'Health Care Number must be 12 digits long.'
    }
  },
  nhsNumber: ({ value }) => isValidNhsNumber(value),
  notBlank: ({ value, label }) => ({
    isValid: typeof value !== 'string' || value.trim().length > 0,
    message: `${label} is required`
  }),
  nonZero: ({ value }) => {
    if (value === '0' || value === 0) {
      return {
        isValid: false,
        message: 'Value must be non-zero'
      }
    }
    return {
      isValid: true
    }
  },
  password: ({ value, relatedValues }) => {
    if (value.length < 5) {
      return {
        isValid: false,
        message: 'Password must be 5 or more characters'
      }
    }
    if (value.length > 32) {
      return {
        isValid: false,
        message: 'Password must be 32 or less characters'
      }
    }
    if (relatedValues && _.some(relatedValues, (val) => val !== value)) {
      return {
        isValid: false,
        message: 'Passwords must match'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },
  pin: ({ value, relatedValues }) => {
    if (
      !value ||
      value.toString().length !== 4 ||
      !_.isNumber(parseInt(value))
    ) {
      return {
        isValid: false,
        message: 'PIN must be 4 digits'
      }
    }
    if (
      relatedValues &&
      _.some(relatedValues, (val) => parseInt(val) !== parseInt(value))
    ) {
      return {
        isValid: false,
        message: 'PINs must match'
      }
    }
    return {
      isValid: true,
      message: ''
    }
  },
  validDate,
  validDateOrNull: ({ value, label }) => {
    if (value === null) {
      return {
        isValid: true,
        message: ''
      }
    }
    return validDate(value, label)
  },
  height: ({ value }) => {
    return {
      isValid: value.toString().length === 3,
      message: 'Height must be 3 digits long'
    }
  }
}

const DATE_FORMAT = 'DD-MM-YYYY'

export default validation
